<template>
<div>
  En cours
</div>
</template>

<style lang="scss">
</style>

<script>
export default {
  name: 'PrescriptionsList',
  props: {
  },
  data: function () {
    return {
    }
  },
}
</script>
